module.exports = __webpack_public_path__ + "fonts/Blogger Sans Medium.f7f32f78.ttf";